import { alphaSorter } from 'vet-bones/utils';

import { Mapping } from 'src/containers/ProjectDiagram/types/data';
import { Model } from 'src/containers/ProjectDiagram/types/model';
import { isMapping } from 'src/containers/ProjectDiagram/utils/data';
import { doMappingUpdated } from 'src/containers/ProjectDiagram/utils/mapping/doMappingUpdated';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

/** adds an attribute as a target for a `field` on Mapping */
export const addMappingField =
  ({
    attributeIri,
    key,
    fieldId,
  }: {
    attributeIri: string;
    key: string;
    fieldId: string;
  }) =>
  (model: Model) => {
    const mapping = model.linkDataArray.find((link) => link.key === key);
    if (!mapping || !isMapping(mapping)) {
      return;
    }

    const field = mapping.fields[fieldId];
    const targets = [...field.targets, attributeIri].sort(alphaSorter);

    setDataProperty<Mapping>(model)(mapping, 'fields', {
      ...mapping.fields,
      [fieldId]: { ...field, targets },
    });

    doMappingUpdated(mapping)(model);
  };
